import React from 'react';
import InquiryPasswordComponent from '../../components/InquiryPassword/InquiryPassword';
import './InquiryPassword.css';

const InquiryPassword: React.FC = () => {
  return (
    <div className="inquiry-password-page">
      <InquiryPasswordComponent />
    </div>
  );
};

export default InquiryPassword;
